<header class="navbar" [class.navbar--scrolled]="isScrolled()">
  <div class="navbar__container">
    <button
      mat-button
      class="navbar__brand"
      (click)="scrollToTop()"
      [attr.aria-label]="profile()?.name + ' főoldal'"
    >
      @if (profile(); as p) {
        <span class="navbar__brand-name">
          {{ p.brandName }}<span class="navbar__brand-accent">{{ p.brandAccent }}</span>
        </span>
      }
    </button>

    <nav class="navbar__nav" aria-label="Főnavigáció">
      @for (item of navItems(); track item.fragment) {
        <button mat-button class="navbar__link" (click)="scrollTo(item.fragment)">
          {{ item.label }}
        </button>
      }
    </nav>

    <div class="navbar__actions">
      <button
        mat-raised-button
        class="btn-primary navbar__cta"
        (click)="scrollTo('kapcsolat')"
      >
        {{ profile()?.navbarCtaLabel }}
      </button>
      <button
        mat-icon-button
        class="navbar__hamburger"
        aria-label="Mobil menü"
        (click)="toggleMenu()"
      >
        <mat-icon>{{ mobileMenuOpen() ? 'close' : 'menu' }}</mat-icon>
      </button>
    </div>
  </div>

  @if (mobileMenuOpen()) {
    <div class="navbar__mobile-menu" role="navigation" aria-label="Mobil navigáció">
      @for (item of navItems(); track item.fragment) {
        <button mat-button class="navbar__mobile-link" (click)="scrollTo(item.fragment)">
          {{ item.label }}
        </button>
      }
      <button
        mat-raised-button
        class="btn-primary navbar__mobile-cta"
        (click)="scrollTo('kapcsolat')"
      >
        {{ profile()?.navbarCtaLabel }}
      </button>
    </div>
  }
</header>
